import  React from 'react';
import './NotificationsMenu.scss';

const NotificationsMenu = (props) => {

  return <ul className="a-list a-list--lined">
    { props.messages.map(({id, message, createdAt, status}) => {
      const className = status === 'unread' ? 'a-list__content is-active' : 'a-list__content';
      const formattedDate = new Date(createdAt).toLocaleDateString();

      const notificationClickedHandler = (e, notification) => {
        e.preventDefault();
        if (notification.status === "unread") {
          props.onNotificationClicked(notification, true);
        } else {
          props.onNotificationClicked(notification);
        }
      }

      return <li className="a-list__item" key={id}>
        <a onClick={(e) => notificationClickedHandler(e, { url: message.link.url, id, status })} href={message.link.url} className={className}>
          <span className="a-list__text">
            {message.message}<br/>
            <small>{formattedDate}</small>
          </span>
        </a>
      </li>
    })}
  </ul>
}

export default NotificationsMenu;
